'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _LabelledInputComponent = require('../input/LabelledInputComponent');

var _LabelledInputComponent2 = _interopRequireDefault(_LabelledInputComponent);

var _TextInputComponent = require('../input/TextInputComponent');

var _TextInputComponent2 = _interopRequireDefault(_TextInputComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreditCardForm = function (_React$Component) {
  _inherits(CreditCardForm, _React$Component);

  function CreditCardForm() {
    _classCallCheck(this, CreditCardForm);

    return _possibleConstructorReturn(this, (CreditCardForm.__proto__ || Object.getPrototypeOf(CreditCardForm)).apply(this, arguments));
  }

  _createClass(CreditCardForm, [{
    key: 'render',
    value: function render() {
      var fields = this.props.fields;


      return _react2.default.createElement(
        _reactBootstrap.Form,
        { id: 'payment-form' },
        _react2.default.createElement(_LabelledInputComponent2.default, {
          inputId: 'creditCardHolderName',
          inputLabel: 'Cardholder Name',
          inputComponent: _TextInputComponent2.default,
          inputComponentField: fields.payment.cardholder_name
        }),
        _react2.default.createElement(
          _reactBootstrap.Row,
          { style: { marginTop: '15px' } },
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 6, className: 'flex-center' },
            _react2.default.createElement(
              'svg',
              {
                xmlns: 'http://www.w3.org/2000/svg',
                width: '16',
                height: '16',
                fill: 'currentColor',
                className: 'bi bi-credit-card',
                viewBox: '0 0 16 16'
              },
              _react2.default.createElement('path', { d: 'M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v1h14V4a1 1 0 0 0-1-1zm13 4H1v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1z' }),
              _react2.default.createElement('path', { d: 'M2 10a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v1a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z' })
            ),
            _react2.default.createElement(_TextInputComponent2.default, {
              id: 'tugoCardNumber',
              className: 'noneborder',
              field: fields.payment.card_number,
              maxLength: 16,
              htmlPlaceholder: 'Card number',
              type: 'num'
            })
          ),
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 2 },
            _react2.default.createElement(_TextInputComponent2.default, {
              id: 'tugoExpiry',
              className: 'noneborder',
              field: fields.payment.expiry,
              maxLength: 7,
              htmlPlaceholder: 'YYYY - MM',
              type: 'num'
            })
          ),
          _react2.default.createElement(
            _reactBootstrap.Col,
            { md: 2 },
            _react2.default.createElement(_TextInputComponent2.default, {
              id: 'tugoCVC',
              className: 'noneborder',
              field: fields.payment.cvv,
              maxLength: 4,
              htmlPlaceholder: 'CVC',
              type: 'num'
            })
          )
        )
      );
    }
  }]);

  return CreditCardForm;
}(_react2.default.Component);

CreditCardForm.propTypes = {
  fields: _react2.default.PropTypes.object
};
exports.default = CreditCardForm;


//////////////////
// WEBPACK FOOTER
// ./src/v2/components/input/TugoCreditCardComponent.jsx
// module id = 1675
// module chunks = 0